import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class CodeAccountListItem extends SearchModelBase {
    accountCode: string = '';
    accountName: string = '';
    glType: string = '';
    subGroup1: string = '';
    subGroup2: string = '';
    iocalDesc: string = '';
    inactive: boolean|null = null;
    remark: string = '';
    id: number = 0;
    inactiveDate: string | null = null;
    isDefault: boolean|null = null;

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'Account Code', width: 85, dataIndex: 'accountCode'}),
        XCol.Create({ col: 1, text: 'Default Account Name', width: 315, dataIndex: 'accountName'}),
        XCol.Create({ col: 2, text: 'Group', width: 130, dataIndex: 'glType'}),
        XCol.Create({ col: 3, text: 'Sub Group 1', width: 170, dataIndex: 'subGroup1'}),
        XCol.Create({ col: 4, text: 'Sub Group 2', width: 170, dataIndex: 'subGroup2'}),
        XCol.Create({ col: 5, text: 'Custom Account Name', width: 320, dataIndex: 'iocalDesc'}),
        XCol.Create({ col: 6, text: 'Inactive', width: 65, dataIndex: 'inactive', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 7, text: 'Inactive Date', width: 65, dataIndex: 'inactiveDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 8, text: 'Remark', width: 350, dataIndex: 'remark'})
        ];


    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: CodeAccountListItem.prototype.accountCode, orderByAscending: true };

    public static formatData(data: CodeAccountListItem[]) {
        return data.map((d: CodeAccountListItem) => ({
          ...d,
        }));
    }

}
